import {cloneDeep, get} from "lodash";
import {getString} from "Core/helpers/data";
import {AppStarterListItemDataObject} from "../dataObjects";
import {getDate, STANDARD_DATE_TIME_FORMAT} from "Core/helpers/datetime";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {AppStarterListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new AppStarterListItemDataObject(
		getString(result, 'id'),
		getString(result, 'jarType'),
		getString(result, 'jarVersion'),
		getDate(get(result, 'jarReleaseDate', null), STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S)
	);

	return result;
}

// @note There is no output function since list is read only.